// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
import "core-js";
require("@rails/ujs").start()
require("turbolinks").start()
require("@rails/activestorage").start()
require("channels")
require("jquery");
require("custom/imagemapresizer.min")
require("custom/search")
require("custom/map")
require("custom/crumb-handler")

import ahoy from "ahoy.js";
import { ready } from "jquery";


$(document).on('turbolinks:load', function(){
  $('.popup-container').addClass(' animate__animated animate__zoomIn');
  // $('.crumb-container').on("mouseenter", function () {
  //     $(this).find(".crumb-title").toggleClass('hover-crumb');
  //     console.log("here")
  // });

});



$(document).on('turbolinks:load', function(){

  $('body').on('click', '.home-leaving-link', function () {
    $('.home-link-popup-container').show()

    console.log("here")
    var infolink = ($(this).attr('infolink'));
    var bottom = ($(this).attr('description'));

    if (bottom) {
        if (bottom.valueOf() == "null") {
        }
    } else {
    }
    $('.popup-link').attr('href', infolink)
})
  $('body').on('click', '.leaving-link', function () {
    $('.link-popup-container').show()

    console.log("here")
    var infolink = ($(this).attr('infolink'));
    var bottom = ($(this).attr('description'));

    if (bottom) {

    } else {
    }
    $('.popup-link').attr('href', infolink)
})
$('.close-button').on('click', function () {
  $('.link-popup-container').hide()
  $('.home-link-popup-container').hide()

})

  $('.content-container').addClass(' animate__animated animate__zoomIn');
  $('.contact-button').on('click', function () {
    $('.contact-pop').show();
  })
  $('.comm-button').on('click', function () {
    $('.comm-pop').show();
  })
  $('.icon').on('click', function () {
    var buttons = document.getElementsByClassName("mobile-btn");

    if (buttons[1].style.display === "none" || buttons[0].style.display === "" ){
      for (var i = 0; i < buttons.length; i++) {
          buttons[i].style.display = "block";
      }


    } else {

      for (i = 0; i < buttons.length; i++) {
          buttons[i].style.display = "none";
          buttons[0].style.display = "block";
      }


    }
  })
  $(".modal-close").on('click', function () {
    $(".popup-container").hide();
  })
});

$(document).on('turbolinks:load', function () {
        var clicked = false
        $(".star").mouseenter(function () {
            if (!clicked) {
              $(this).addClass("filled")
              $(this).prevAll(".star").addClass("filled");
            }

        });
        $(".star").mouseleave(function () {
            if (!clicked) {
                $('.star').removeClass("filled")
            }

        });
        $(".close-button").click(function () {
          $('.rating-popup').hide();

        })
        $(".star").click(function () {
            clicked = true;
            $(this).addClass("filled");
            $(this).prevAll(".star").addClass("filled");
            $('.rating-popup').show();
          $.ajax({
            url: "/rated",
            type: 'post',
            data: {rating:  $(this).data('rating')} ,
          });

        })
})




// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)
